<template>
  <v-container fluid>
    <v-row class="d-flex justify-space-around">
      <div v-for="catalog in catalogs" :key="catalog.title" class="mx-5 mb-5">
        <inertia-link :href="route(catalog.route, offerData.id)">
          <v-hover v-slot="{ hover }">
            <v-card
              color="grey lighten-3"
              elevation="1"
              :class="{ 'on-hover': hover }"
            >
              <v-img :src="catalog.img" :height="size" :width="size">
                <v-row align="end" class="fill-height">
                  <v-col
                    align-self="end"
                    cols="12"
                    color="grey"
                    style="background: url()"
                  >
                    <v-sheet
                      class="mt-auto align-center justify-center d-flex px-2"
                      color="rgba(0, 0, 0, .36)"
                      dark
                      height="50px"
                    >
                      {{ catalog.title }}
                      <v-icon v-if="catalog.created" color="green">
                        mdi-check
                      </v-icon>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-img>
            </v-card>
          </v-hover>
        </inertia-link>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12">
        <inertia-link :href="route('offerData.show', offerData.id)">
          <v-btn block class="bar-btn primary-bg white--text" text dark>
            Zur Angebotsübersicht
          </v-btn>
        </inertia-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Angebotstyp',
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      offerData: {
         type: Object,
         required: true,
      },
      catalogs: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         stepper: 1,
         maxStep: 1,
         orderid: null,
         loading: false,
      }
   },
   computed: {
      size () {
         switch (this.$vuetify.breakpoint.name) {
         case 'md': return '300'
         case 'lg': return '400'
         case 'xl': return '400'
         default: return '230'
         }
      }
   }
}
</script>
<style scoped>
.v-card:not(.on-hover) {
  opacity: 0.75;
 }
</style>
